/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from '@micromag/core/components';

const propTypes = {
    startDates: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            label: PropTypes.string,
        }),
    ).isRequired,
    selectedName: PropTypes.string,
    onItemClick: PropTypes.func,
    className: PropTypes.string,
};

const defaultProps = {
    selectedName: null,
    onItemClick: null,
    className: null,
};

const AnalyticsStartDate = ({ startDates, selectedName, onItemClick, className }) => (
    <div
        className={classNames([
            {
                [className]: className !== null,
            },
            'btn-group',
        ])}
    >
        {startDates !== null
            ? startDates.map(({ name, label }, i) => (
                  <Button
                      key={`analytics-button-${i + 1}`}
                      onClick={() => {
                          onItemClick(name);
                      }}
                      theme="secondary"
                      className={classNames([selectedName === name ? 'active' : ''])}
                  >
                      {label}
                  </Button>
              ))
            : null}
    </div>
);

AnalyticsStartDate.propTypes = propTypes;
AnalyticsStartDate.defaultProps = defaultProps;

export default AnalyticsStartDate;
